@let selectedHome = selectedHomeName() ?? '' | currentLanguageV2: true;
@if (selectableHomes().length > 1) {
    @let id = 'home-selector-menu';
    <h1 data-testid="dw-home-title">
        <button
            #homeSelectorOrigin="cdkOverlayOrigin"
            cdkOverlayOrigin
            interacta-menu-button
            type="button"
            [attr.aria-controls]="id"
            [attr.aria-expanded]="isOpen()"
            [label]="selectedHome"
            [size]="'large'"
            (click)="isOpen.set(true)"
        ></button>
    </h1>
    <interacta-menu
        [classes]="'min-w-300 max-h-[min(80vh,17.625rem)] py-16'"
        [id]="id"
        [open]="isOpen()"
        [origin]="homeSelectorOrigin"
        [overridePositions]="[
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
                offsetY: 4,
            },
        ]"
        (closing)="isOpen.set(false)"
    >
        @for (item of selectableHomes(); track item.id) {
            <button
                class="justify-between"
                interactaMenuItemDecorator
                type="button"
                (click)="itemSelected(item)"
            >
                <p class="typo-medium">
                    {{ item.name | currentLanguageV2: true }}
                </p>
                <div class="flex items-center gap-x-8">
                    @if (item.isNew) {
                        <p
                            class="flex h-24 items-center rounded-full border px-8 typo-xs"
                        >
                            {{ 'DIGITAL_WORKPLACE.NEW_HOME_BADGE' | translate }}
                        </p>
                    }
                    @if (item.id === currentHomeId()) {
                        <interacta-icon
                            class="size-16 text-system-success"
                            [icon]="'check'"
                        />
                    }
                </div>
            </button>
        }
    </interacta-menu>
} @else {
    <h1 data-testid="dw-home-title" [ngClass]="isMd() ? 'typo-t5' : 'typo-t6'">
        {{ selectedHome }}
    </h1>
}
